import { Phone, ArrowRight, Clock, Calendar, User } from 'lucide-react';
import { Link } from 'react-router-dom';

const WHATSAPP_LINK = "https://wa.me/5541988451399?text=Olá,%20gostaria%20de%20agendar%20uma%20avaliação%20médica.";

// Placeholder blog posts
const blogPosts = [
  {
    id: 1,
    title: 'Por que a maioria das dietas falham?',
    excerpt: 'A maioria das pessoas não falha por falta de esforço. Ela falha porque tenta resolver um problema médico complexo com soluções genéricas.',
    category: 'Emagrecimento',
    date: 'Em breve',
    readTime: '5 min',
  },
  {
    id: 2,
    title: 'Reposição hormonal: mitos e verdades',
    excerpt: 'Quando hormônios viram moda, o risco vira rotina. Entenda a diferença entre reposição responsável e uso indiscriminado.',
    category: 'Reposição Hormonal',
    date: 'Em breve',
    readTime: '7 min',
  },
  {
    id: 3,
    title: 'O que esperar da primeira consulta',
    excerpt: 'A primeira consulta não é apenas uma conversa rápida. É uma avaliação médica aprofundada para entender seu caso.',
    category: 'Acompanhamento',
    date: 'Em breve',
    readTime: '4 min',
  },
  {
    id: 4,
    title: 'Efeito sanfona: causas e como evitar',
    excerpt: 'O ciclo de perder e ganhar peso pode ser evitado com acompanhamento médico adequado e tratamento individualizado.',
    category: 'Emagrecimento',
    date: 'Em breve',
    readTime: '6 min',
  },
  {
    id: 5,
    title: 'Sintomas de desequilíbrio hormonal',
    excerpt: 'Cansaço, ganho de peso, alterações de humor... saiba identificar os sinais de que seu corpo pode precisar de atenção.',
    category: 'Reposição Hormonal',
    date: 'Em breve',
    readTime: '5 min',
  },
  {
    id: 6,
    title: 'A importância do acompanhamento contínuo',
    excerpt: 'Emagrecimento e equilíbrio hormonal não são eventos pontuais. São processos que exigem suporte ao longo do caminho.',
    category: 'Acompanhamento',
    date: 'Em breve',
    readTime: '4 min',
  },
];

const categories = ['Todos', 'Emagrecimento', 'Reposição Hormonal', 'Acompanhamento'];

export const BlogPage = () => {
  return (
    <main data-testid="blog-page" className="pt-24">
      {/* Hero */}
      <section className="section-padding bg-[#FAF9F7]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <p className="text-sm uppercase tracking-[0.2em] text-[#B8944D] mb-6">
              Blog e Artigos
            </p>
            
            <h1 
              className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-8"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Conteúdo médico<br />
              <span className="text-[#B8944D]">com responsabilidade</span>.
            </h1>
            
            <p className="text-lg text-[#666666] leading-relaxed">
              Informações sobre emagrecimento clínico, reposição hormonal e saúde baseadas em ciência e experiência médica real.
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 bg-white border-b border-[#E5E2DD]">
        <div className="container-custom">
          <div className="flex flex-wrap gap-3">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-5 py-2 rounded-full text-sm transition-all ${
                  index === 0 
                    ? 'bg-[#B8944D] text-white' 
                    : 'bg-[#FAF9F7] text-[#666666] hover:bg-[#E5E2DD]'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article 
                key={post.id}
                className="card-premium group cursor-pointer"
                data-testid={`blog-post-${post.id}`}
              >
                {/* Category Badge */}
                <span className="inline-block px-3 py-1 bg-[#B8944D]/10 text-[#B8944D] text-xs font-medium rounded-full mb-4">
                  {post.category}
                </span>
                
                {/* Title */}
                <h2 
                  className="text-xl text-[#2A2A2A] mb-3 group-hover:text-[#B8944D] transition-colors"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {post.title}
                </h2>
                
                {/* Excerpt */}
                <p className="text-[#666666] text-sm leading-relaxed mb-6 line-clamp-3">
                  {post.excerpt}
                </p>
                
                {/* Meta */}
                <div className="flex items-center justify-between text-xs text-[#888888] mt-auto pt-4 border-t border-[#E5E2DD]">
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      {post.readTime}
                    </span>
                  </div>
                  <ArrowRight className="w-4 h-4 text-[#B8944D] opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </article>
            ))}
          </div>
          
          {/* Coming Soon Message */}
          <div className="text-center mt-16 p-8 bg-[#FAF9F7] rounded-md">
            <p className="text-lg text-[#666666] mb-2">
              Novos artigos em breve.
            </p>
            <p className="text-sm text-[#888888]">
              Conteúdo médico responsável, baseado em ciência e experiência clínica real.
            </p>
          </div>
        </div>
      </section>

      {/* Newsletter / CTA */}
      <section className="section-padding bg-[#E5E2DD]/30">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <h2 
              className="section-title mb-6"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Quer tirar suas dúvidas?
            </h2>
            
            <p className="text-lg text-[#666666] mb-8">
              Entre em contato diretamente comigo pelo WhatsApp. Terei prazer em esclarecer suas questões sobre emagrecimento clínico e reposição hormonal.
            </p>
            
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="blog-cta-button"
              className="btn-primary inline-flex items-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Falar pelo WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="section-padding bg-[#2A2A2A] text-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 
              className="text-3xl md:text-4xl text-white mb-6 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Pronto para dar o primeiro passo?
            </h2>
            
            <p className="text-lg text-white/70 mb-10">
              Agende uma avaliação médica e entenda se o meu acompanhamento faz sentido para o seu caso.
            </p>
            
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="blog-cta-final-button"
              className="btn-primary inline-flex items-center gap-2 text-lg"
            >
              <Phone className="w-5 h-5" />
              Agendar avaliação médica
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};
